<template>
  <div class="Showcase">
    <div class="Showcase__frame">
      <PlanWeekIllustration />
    </div>

    <div v-if="ask" class="Float Float--ask" aria-hidden="true">{{ ask }}</div>
    <div v-else-if="ftp" class="Float Float--ftp" aria-hidden="true">
      <span class="Float__label">New FTP detected</span>
      <span class="Float__big">
        266
        <small>W</small>
      </span>
      <span class="Float__up">Up 12 W since you started</span>
    </div>

    <div v-if="note" class="Float Float--note" aria-hidden="true">
      <span class="Float__mark"></span>
      <span>
        <span v-if="noteLabel" class="Float__who">{{ noteLabel }}</span>
        {{ note }}
      </span>
    </div>
  </div>
</template>

<script>
import PlanWeekIllustration from 'components/PlanWeekIllustration'

// The plan week (PlanArt) in a frame, with up to two floating cards: a rider's
// message to the coach or a new FTP on top, and what the plan did below. Made
// for dark sections (landing hero, plan promos on the homepage and coach page).
export default {
  name: 'PlanShowcase',
  components: { PlanWeekIllustration },
  props: {
    ftp: { type: Boolean, default: false },
    ask: { type: String, default: null },
    note: { type: String, default: null },
    noteLabel: { type: String, default: null }
  }
}
</script>

<style lang="postcss" scoped>
.Showcase {
  @apply relative;
}
.Showcase__frame {
  @apply overflow-hidden text-gray-900;
  border-radius: 24px;
  box-shadow: 0 50px 100px -40px rgba(0, 0, 0, 0.8);
}
.Showcase__frame ::v-deep .PlanArt {
  @apply py-12;
}

/* Cards hide on phones, where they would cover the week. */
.Float {
  @apply absolute hidden;
}
@media (min-width: 768px) {
  .Float {
    @apply flex;
  }
}
.Float--ftp {
  @apply flex-col px-5 py-4 text-gray-900 bg-white;
  top: -1.75rem;
  right: -0.5rem;
  border-radius: 16px;
  box-shadow: 0 24px 48px -20px rgba(0, 0, 0, 0.55);
}
.Float--ask {
  @apply px-5 py-3 text-lg font-semibold text-gray-900 bg-white;
  top: -1.5rem;
  right: -0.5rem;
  border-radius: 20px 20px 4px 20px;
  box-shadow: 0 24px 48px -20px rgba(0, 0, 0, 0.55);
}
.Float__label {
  @apply text-xs font-semibold text-gray-700;
}
.Float__big {
  @apply mt-1 font-bold;
  font-size: 2.25rem;
  line-height: 1;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
}
.Float__big small {
  @apply text-base font-semibold text-gray-700;
}
.Float__up {
  @apply mt-1 text-sm font-semibold;
  color: #276749;
}
.Float--note {
  @apply items-start gap-3 px-5 py-4 text-sm leading-snug;
  left: -1.5rem;
  bottom: -2rem;
  max-width: 21rem;
  color: rgba(232, 238, 242, 0.95);
  background: rgba(4, 20, 26, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  backdrop-filter: blur(8px);
}
.Float__mark {
  @apply flex-shrink-0 mt-1 rounded-full;
  width: 9px;
  height: 9px;
  background: #b6ffc9;
  box-shadow: 0 0 12px rgba(182, 255, 201, 0.7);
}
.Float__who {
  @apply block mb-1 text-xs font-semibold;
  color: #b6ffc9;
}
</style>
